var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 568.23 568.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffead0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stop"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157,372.2V182.1s2-49.1-27.27-53.9v-26H499l-.41,25.8c-.4.12-31.59,4-31.59,53.2v194c0-.2-1,50,31.06,50v40.07H129.73l.54-38.27C130,427,157,429,157,372.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopButton);
export default __webpack_public_path__ + "static/media/stop-button.e0df94679124bd4b7af48fee64b9424d.svg";
export { ForwardRef as ReactComponent };